import { IOrderPriceGrace, IBasketOrderPriceDiscount } from "../order/types";

export default class BasketPrice {

  amount: number;
  installments: number;
  discounts: IBasketOrderPriceDiscount[];
  grace?: IOrderPriceGrace;
  participation?: number;

  constructor(amount: number, installments: number, discounts: IBasketOrderPriceDiscount[], grace: IOrderPriceGrace | undefined, participation: number | undefined) {
    this.amount = amount;
    this.installments = installments;
    this.discounts = discounts;
    this.grace = grace;
    this.participation = participation;
  }

}
